import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export const useDeviceWidth = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "lg"));
  const isTabletMobile = useMediaQuery(theme.breakpoints.down("lg"));
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));

  return {
    isMobile,
    isDesktop,
    isTablet,
    isTabletMobile,
  };
};
